import React, { useEffect, useCallback } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useTable, useSortBy, usePagination, useFilters, useGlobalFilter } from "react-table";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useMemo, useState } from "react";
import "../../StyleSheet/AppComponent/ReactTable/ReactTable.scss";
import boximg from "../../Assets/AppComponent/Group 427320177.svg";


const RmOnboarderTable = (props) => {
  
  const columns = useMemo(() => props.columns);
  const data = props.data;



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    rowsPerPage,
  } = useTable({
    columns,
    data,
  });

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: props.dtpageindex,
        pageSize: props.dtpagesize,
      },
      manualPagination: true,
      pageCount:
        props.datacount < 20 || props.datacount == null
          ? 1
          : Math.ceil(props.datacount / props.dtpagesize + 1),
    },
  
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,

  );
  
  const {
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    state,
    visibleColumns,
    setGlobalFilter,
    preGlobalFilteredRows,
    previousPage,
    setPageSize,

    state: { pageIndex, pageSize },
  } = tableInstance;

    const handleNext = (e) => {
    props.onNextpage(pageIndex);
  };



  const HandlePrevious = (e) => {
    props.onPrevious(e);
  };
  const [goPage, setGoPage] = useState(1);
  const handleGotoPage = (e) => {
    e.preventDefault();
  };
  const GotoThePage = () => {
    const goPageNumber = Number(goPage);

    if (
      Math.ceil(
        props.datacount == null ? 1 : props.datacount / props.dtpagesize
      ) >= goPageNumber ||
      goPageNumber == ""
    ) {
      if (props.id === "spe" || props.id === "sym") {
        // props.setsno((newPageIndex - 1) * 20);
        props.setsno((goPageNumber - 1) * 20); // Set sno based on the page number
      }
      gotoPage(goPageNumber);
      props.GotoEnteredPage(goPageNumber);
    } else {
      toast.error("Invalid Page Number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };



  return (
    <>
      <>
        <div className="row no-zoom">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
          
                <div className="table-responsive">
                  <div className="INNERTABLE">
                    <table {...getTableProps()} className="TableDesgin">
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()}
                            className="innerHead"
                          >
                            {headerGroup.headers.map((column) => (
                              <th {...column.getHeaderProps()}

                              >
                                {column.render("Header")}

                         

                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      {data != undefined &&
                        page.length > 0 &&
                        data.length > 0 ? (
                        <tbody {...getTableBodyProps()} className="tbodyReact">
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr
                                {...row.getRowProps()}
                                className={`InnerBodyTR 
                                  `}
                              >
                                {row.cells.map((cell) => {
                                  return (
                                    <td {...cell.getCellProps()}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        <>
                       

                        </>
                      )}


                    </table>
                    <>
                        {data != undefined &&
                          page.length > 0 &&
                          data.length > 0 ?
                          <>
                          </>
                          : <>
                            <div>

                              <div className="Dusbinbacktabls">

                                <div>
                                  <img src={boximg} />
                                  <p className="text-center">
                                    { "No Data Available"} 
                                    </p>

                                </div>
                              </div>
                            </div>
                          </>
                        }
                      </>
                  </div>

                  <div
                    className="row"
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      margin: "0",
                    }}
                  >
                    {props.datacount > 20 ? (
                      <div
                        className="pagination"
                        style={{ justifyContent: "end", width: "100%" }}
                      >
                        <div
                          className=" pagination"
                          style={{ justifyContent: "end" }}
                        >
                          <div className="showrow1" style={{ padding: "4px" }}>

                            <button
                              className="btn btn prim"
                              style={{ border: "none" }}
                              onClick={() => {
                                HandlePrevious(props.dtpageindex - 1);
                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno(props.sno - 20);
                                }
                              }}
                              disabled={pageIndex == 1}
                            >
                              {"<"}
                            </button>
                            <span style={{ padding: "10px" }}>
                         

                              <strong style={{ fontSize: "12px" }}>

                                {pageIndex} of{" "}
                                {Math.ceil(
                                  props.datacount == null
                                    ? 1
                                    : props.datacount / props.dtpagesize
                                )}{" "}
                              </strong>
                            </span>

                            <button
                              style={{ border: "none" }}
                              className="btn btn prim"
                              onClick={() => {
                                handleNext(props.dtpageindex + 1);

                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno(props.sno + 20);
                                }
                              }}
                              disabled={
                                pageIndex ==
                                Math.ceil(props.datacount / props.dtpagesize)
                              }
                            >
                              {">"}
                            </button>

                            <span className="GOTOPageOuters">
                              <form
                                className="GotoPageForm  GotoPageFormtable"
                                onSubmit={handleGotoPage}
                              >
                                <span className="GotoPageText">Go to Page</span>
                                <input
                                  type="number"
                                  value={goPage}
                                  className="formcontrol_Table"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const newPageIndex = e.target.value;
                                  

                                    if (!isNaN(newPageIndex)) {

                                      if (
                                        newPageIndex != 0 &&
                                        newPageIndex > 0
                                      ) {
                                        setGoPage(newPageIndex);
                                      } else if (
                                        newPageIndex == 0 ||
                                        newPageIndex < 0
                                      ) {
                                        setGoPage("");
                                      }
                                    }
                                  }}
                                  step="1"
                                  onKeyDown={(evt) => {
                                    if (
                                      ["e", "E", "+", "-", "."].includes(
                                        evt.key
                                      )
                                    ) {
                                      evt.preventDefault();
                                    }
                                  }}
                                />

                                <button
                                  type="submit"
                                  className="GOBTON btn"
                                  disabled={goPage == ""}
                                  onClick={(e) => {
                                    GotoThePage();
                                  }}
                                >
                                  Go
                                </button>
                              </form>
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default RmOnboarderTable;